import { render, staticRenderFns } from "./departmentServiceViewer.vue?vue&type=template&id=cc08b86a"
import script from "./departmentServiceViewer.vue?vue&type=script&lang=js"
export * from "./departmentServiceViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports